export const EVENT_COMMON_TIP = 'EVENT_COMMON_TIP';
export const EVENT_LOGIN = 'EVENT_LOGIN';
export const EVENT_LOGIN_OUT = 'EVENT_LOGIN_OUT';
export const EVENT_AUTHORITY_ERROR = 'EVENT_AUTHORITY_ERROR';
export const EVENT_REFRESH_USER = 'EVENT_REFRESH_USER';
export const EVENT_OTHER_INPUT = 'EVENT_OTHER_INPUT';
export const EVENT_MY_INPUT = 'EVENT_MY_INPUT';
export const EVENT_INPUT_SUBMIT = 'EVENT_INPUT_SUBMIT';
export const EVENT_RES_BEGIN = 'EVENT_RES_BEGIN';
export const EVENT_RES_OVER = 'EVENT_RES_OVER';
export const EVENT_SIMPLE_SUBMIT = 'EVENT_SIMPLE_SUBMIT';
export const EVENT_SIMPLE_RES = 'EVENT_SIMPLE_RES';
export const EVENT_PLAY_AUDIO = 'EVENT_PLAY_AUDIO';
export const EVENT_REFRESH_MESSAGE = 'EVENT_REFRESH_MESSAGE';
export const EVENT_RESET_CHAT = 'EVENT_RESET_CHAT';
export const EVENT_CHAT_SCROLL = 'EVENT_CHAT_SCROLL';
export const EVENT_LATEST_ROLE = 'EVENT_LATEST_ROLE';
export const EVENT_INTIMACY_UPDATE = 'EVENT_INTIMACY_UPDATE';
export const EVENT_NEED_SUBSCRIBE = 'EVENT_NEED_SUBSCRIBE';
export const EVENT_ROOM_TIP = 'EVENT_ROOM_TIP';
export const EVENT_CHECK_MEDIA = 'EVENT_CHECK_MEDIA';
export const EVENT_SHOW_GIFTS = 'EVENT_SHOW_GIFTS';
export const EVENT_GUIDE_DIALOG = 'EVENT_GUIDE_DIALOG';
export const EVENT_GIFT_ANI = 'EVENT_GIFT_ANI';
export const EVENT_IM_MESSAGE = 'EVENT_IM_MESSAGE';
export const EVENT_ENTER_ROOM = 'EVENT_ENTER_ROOM';
export const EVENT_CALL_END = 'EVENT_CALL_END';
export const EVENT_GLOBAL_CANCEL = 'EVENT_GLOBAL_CANCEL';
export const EVENT_CHAT_WITH = 'EVENT_CHAT_WITH';
export const EVENT_HOW_TO_USE = 'EVENT_HOW_TO_USE';
export const EVENT_EMAIL_SUCCESS = 'EVENT_EMAIL_SUCCESS';
export const EVENT_RECHARGE_SUCCESS = 'EVENT_RECHARGE_SUCCESS';
export const EVENT_USERINFO_SUCCESS = 'EVENT_USERINFO_SUCCESS';
